'use client';
import React from 'react';
import Hero from './hero';
import Content from './content';
import Navigation from './navigation';
import Forthsection from './forthsection';
import LastContent from './lastContent';
import Backforward from '../backforward';
import Twako from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  return (
    <div>
      <title>Dallas Fort Worth International Airport – A Guide</title>
      <meta
        name="description"
        content="The ultimate guide you need to learn about Dallas Fort Worth International Airport and its terminals, gates, lounges, and more."
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Dallas Fort Worth International Airport – A Guide"
      />
      <meta
        property="og:description"
        content="The ultimate guide you need to learn about Dallas Fort Worth International Airport and its terminals, gates, lounges, and more"
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="Dallas Fort Worth International Airport – A Guide"
      />
      <meta
        name="twitter:description"
        content="The ultimate guide you need to learn about Dallas Fort Worth International Airport and its terminals, gates, lounges, and more"
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/guide-to-dallas-fort-worth-international-airport-dfw"
      />
      <Navbar />
      <Hero />
      <Content />
      <Navigation />
      <Forthsection />
      <LastContent />
      <Backforward />
      <Twako />
      <Footer />
    </div>
  );
}

export default page;
